import * as React from "react";
import {Badge} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ScrollToTopButton from '../utils/scroll-to-top-button';
import OrderMenuModalMobile from './modals/order-menu-modal-mobile';
import IDelivery from '../interfaces/IDelivery';
import { ActionButton } from '../utils/action-button';
import { Link } from 'react-router-dom';
import IProduct from '../interfaces/IProduct';


export default function OrderMobileButton(props: { deliveryOptions?: IDelivery; cartItems: any; totalPrice: any; setCartState?: any; drinks?: IProduct[]; addItem?: any }) {
    const cartItems = props.cartItems;
    const totalPrice = props.totalPrice;
    const setCartState = props.setCartState;
    const deliveryOptions = props.deliveryOptions;
    const drinks = props.drinks;
    const addItem = props.addItem;

    const [open, setOpen] = React.useState(false);

    const totalItemAmount = () => {
        let totalAmount = 0;
        cartItems.map((item: any) => {
            totalAmount += item.quantity
        })

        return totalAmount;
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className="order-button-mobile-outer">

            <div className="top-button-container-mobile">
                <ScrollToTopButton isMobile={true} />
            </div>
            {cartItems.length > 0 &&
                <div className="order-button-mobile">
                    <ActionButton
                        onClick={() => handleClickOpen()}
                        variant="contained"
                        color="secondary">
                        <Badge badgeContent={totalItemAmount()} color="primary">
                            <ShoppingCartIcon className="mr-1" fontSize="small" />
                        </Badge>
                        <div className="pl-3 py-1">Bekijk bestelling (€{totalPrice.toFixed(2).replace(".", ",")})</div>
                    </ActionButton>

                    <OrderMenuModalMobile
                        drinks={drinks}
                        addItem={addItem}
                        setCartState={setCartState}
                        deliveryOptions={deliveryOptions}
                        totalPrice={totalPrice}
                        open={open}
                        onClose={handleClose}
                        cartItems={cartItems}
                    />
                </div>
            }
        </div>
    )
}